import { IExistingChangeRequestViewModel } from '../types/existingChangeRequestViewModel'

export class ExistingChangeRequestViewModel implements IExistingChangeRequestViewModel
{
    hasExistingChangeRequest: boolean = false
    referenceNumber: string[] = []
}